import { IEmailRequest } from '@ml/common';

export class EmailRequest implements IEmailRequest {
  recipients: string;
  cc: string;
  replyto: string;
  subject: string;
  body: string;
  topcontent: string;
  bottomcontent: string;
  filecontent: string;
  filename: string;
  isHtml: boolean;
  communityIdForSettings: number;
  clientIdForSettings: number;

  constructor(recipients: string, clientId: number, title: string, message: string) {
    this.recipients = recipients;
    this.subject = title;
    this.body = message;
    this.clientIdForSettings = clientId;
  }

  mapToFormData(): FormData {
    const formData = new FormData();
    formData.set('mailDTO', JSON.stringify(this as IEmailRequest));
    return formData;
  }
}
